export default "__VITE_ASSET__Blruh3cK__"